module.exports = __webpack_public_path__ + "static/3-bf56d6eb2837943c0ffc944aa316fae8.png";